import { Component } from 'preact'
import axios from 'axios'
import Phrase from '../../libs/translationsUtils/phrase'

class OEmbed extends Component {
  constructor () {
    super()
    this.state = {
      embedCode: null,
      hasError: false,
      hasAccess: false
    }
  }

  componentDidMount () {
    axios.get('/oembed/getembeddedUrl?url=' + this.props.url)
      .then(res => {
        this.setState({ embedCode: res.data.html.replace('http://', 'https://'), hasAccess: true })
      })
      .catch((error) => {
        if (error.response && error.response.status === 403) {
          this.setState({ hasError: true })
        } else {
          this.setState({ hasError: true, hasAccess: true })
        }
      })
  }

  render (props, state) {
    if (!state.hasAccess) {
      return (
        <a target='_blank' href={props.url} rel='noreferrer nofollow noopener'>{ props.url }</a>
      )
    }
    return (
      <div className='oembed-wrapper'>
        {
          state.hasError ? <div className='box box__pad box--note'><Phrase p='embeddable.not.available' /></div>
            : <div className='oembed-iframe-wrapper' dangerouslySetInnerHTML={{ __html: state.embedCode }} />
        }
      </div>
    )
  }
}

export default OEmbed
